/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {searchForFormById} from '../../../selectors/searchForForm';
import {searchForEstablishmentById} from '../../../selectors/searchForEstablishment';
import * as FormName from '../../../constants/formNameConstants';
import * as establishmentActions from '../../../actions/establishmentActions';
import EstablishmentHeader from './EstablishmentHeader';
import InjurySummaryTable from '../../injurySummary/InjurySummaryTable/InjurySummaryTable';
import '../../../styles/establishment/establishmentSingleView.css';
import {createInjurySummaryObject} from '../../injurySummary/injurySummaryModel';

class SubmissionPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      injurySummary: this.props.injurySummary,
      submission: this.props.submission
    };

  }

  componentDidMount() {
    if (Object.keys(this.state.submission).length === 0 &&
      this.state.submission.constructor === Object &&
      this.props.submissionLinks.length > 0) {
      this.props.submissionLinks.forEach(link => {
        this.props.actions
          .loadSubmissionData(link);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.submission.id != nextProps.submission.id) {
      // Necessary to populate form when existing course is loaded directly.
      this.setState({submission: Object.assign({}, nextProps.submission)});
    }
  }

  render() {
    let injurySummaryTable = '';
    let establishmentInfo = '';
    let submissionMsg = '';
    if (this.props.formId) {
      injurySummaryTable =
        (<InjurySummaryTable
          injurySummary={this.props.injurySummary}
          form={this.props.questionForm}
          showEmployeeInfo={true}/>);
    }
    if (this.props.submission.establishment) {
      establishmentInfo = (<EstablishmentHeader
        establishment={this.props.establishment}
        submission={true}/>);
    }
    if (this.props.username && this.props.timestamp) {
      submissionMsg = (<div className="col-xs-12 col-sm-9 alert alert-info">
        <div className="first-line">
          Submitted on {this.props.timestamp} by {this.props.username}.
        </div>
      </div>);
    }
    return (
      <div id="establishment-single-page">
        {submissionMsg}
        <div className="row">
          {establishmentInfo}
        </div>

        <div className="border-container injury-summary-container">
          <h2 id="injury-summary-table-title">Summary for Filing Year {this.props.injurySummary.filingYear}</h2>

          <div hidden={!this.props.formId}>
            {injurySummaryTable}
          </div>
        </div>
      </div>
    );
  }
}

SubmissionPage.propTypes = {
  establishment: PropTypes.object.isRequired,
  establishmentId: PropTypes.string.isRequired,
  injurySummary: PropTypes.object.isRequired,
  username: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired,
  submissionLinks: PropTypes.array.isRequired,
  submission: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  questionForm: PropTypes.object.isRequired,
  user: PropTypes.object,
  formId: PropTypes.number
};

function getSubmissionDataByIds(submissions, id, submissionId) {
  const submission = submissions.filter(submission => {
    if (submission.establishment.id == id &&
      submission.id == submissionId) {
        return submission;
    }
  });

  if (submission) {
    return submission[0];
  }
  return null;
}

function mapStateToProps(state, ownProps) {
  // from the path `/establishment/:establishmentId/submission/submissionId`
  const establishmentId = ownProps.params.establishmentId;
  const establishmentEntry = searchForEstablishmentById(state.establishments, establishmentId);
  const submissionId = ownProps.routeParams.submissionId;
  let questionForm = {};
  if (state.forms.length > 0) {
    questionForm =
      searchForFormById(state.forms, FormName.itaInjurySummaryFormId);
  }

  let submission = {};
  let submissionLinks = [];
  if (establishmentEntry && establishmentEntry.links &&
    establishmentEntry.links.submission_links) {
    establishmentEntry.links.submission_links.forEach(link => {
      submissionLinks.push(link);
    });
  }

  if (state.submissions && state.submissions.length > 0) {
    submission =
      getSubmissionDataByIds(state.submissions, establishmentId, submissionId)
      || {};
  }

  let injurySummary = {};
  if (submission.form300a) {
    injurySummary = createInjurySummaryObject(submission.form300a);
  }
  let username = '';
  if (submission.created_username) {
    username = submission.created_username;
  }
  let timestamp = '';
  if (submission.time_stamp) {
    let d = new Date(submission.time_stamp);
    const month = (d.getUTCMonth() + 1).toString();
    const day = d.getUTCDate().toString();
    const year = d.getUTCFullYear().toString();
    const hours = d.getHours();
    const minutes = d.getMinutes();
    let timeOfDay = "AM";
    let formattedHours = hours;

    if(hours >= 12) {
      timeOfDay = "PM";
    }

    if(hours > 12) {
      formattedHours = hours - 12;
    }

    if(hours === 0) {
      formattedHours = 12;
    }

   timestamp = `${month}/${day}/${year} ${formattedHours}:${minutes} ${timeOfDay}`;
  }
  let establishment = {};
  if (submission.establishment) {
    establishment = submission.establishment;
  }

  let formId = null;


  if (injurySummary.id) {
    formId = injurySummary.id;
  }
  return {
    establishment,
    establishmentId,
    username,
    timestamp,
    submission,
    submissionLinks,
    injurySummary,
    formId,
    questionForm,
    user: state.user[state.user.length - 1]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(establishmentActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionPage);



/** WEBPACK FOOTER **
 ** ./src/components/establishment/singleEstablishment/SubmissionPage.js
 **/